import styled, { css } from 'styled-components';
import Button from '../../components/Button';

interface ContainerProps {
  $useStyle: boolean;
  $mainColor: string; // b31c1d ->TSO
  $buttonStyle: string;
  $boxQuestionType: string;
  $showFinalMessage: boolean;
  $hideProgressText?: boolean;
  $buttonPosition?: string;
  $fontFamily?: string;
}

interface HeaderProps {
  $useStyle: boolean;
  $headerColor: string;
  $sizeLogo: string;
  $showTitle: boolean | undefined;
}

interface ButtonStyle {
  $buttonColor: string;
}

interface BackgroundImageProps {
  $urlBackground: string;
  $buttonColor: string;
  $boxSize: string;
}

function getPolaritySliderClasses(__buttonColor: string): string {
  return `

  /* 3 options  */

  .polarity-slider3 .noUi-handle[aria-valuenow="1.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }
  .polarity-slider3 .noUi-handle[aria-valuenow="2.0"] .noUi-touch-area{
    background: ${__buttonColor}70 !important;
  }
  .polarity-slider3 .noUi-handle[aria-valuenow="3.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }

  /* 5 options  */

  .polarity-slider5 .noUi-handle[aria-valuenow="1.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }
  .polarity-slider5 .noUi-handle[aria-valuenow="2.0"] .noUi-touch-area{
    background: ${__buttonColor}B0 !important;
  }
  .polarity-slider5 .noUi-handle[aria-valuenow="3.0"] .noUi-touch-area{
    background: ${__buttonColor}70 !important;
  }
  .polarity-slider5 .noUi-handle[aria-valuenow="4.0"] .noUi-touch-area{
    background: ${__buttonColor}B0 !important;
  }
  .polarity-slider5 .noUi-handle[aria-valuenow="5.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }

  /* 7 options  */

  .polarity-slider7 .noUi-handle[aria-valuenow="1.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }
  .polarity-slider7 .noUi-handle[aria-valuenow="2.0"] .noUi-touch-area{
    background: ${__buttonColor}D8 !important;
  }
  .polarity-slider7 .noUi-handle[aria-valuenow="3.0"] .noUi-touch-area{
    background: ${__buttonColor}A8 !important;
  }
  .polarity-slider7 .noUi-handle[aria-valuenow="4.0"] .noUi-touch-area{
    background: ${__buttonColor}70 !important;
  }
  .polarity-slider7 .noUi-handle[aria-valuenow="5.0"] .noUi-touch-area{
    background: ${__buttonColor}A8 !important;
  }
  .polarity-slider7 .noUi-handle[aria-valuenow="6.0"] .noUi-touch-area{
    background: ${__buttonColor}D8 !important;
  }
  .polarity-slider7 .noUi-handle[aria-valuenow="7.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }

  /* 9 options  */

  .polarity-slider9 .noUi-handle[aria-valuenow="1.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="2.0"] .noUi-touch-area{
    background: ${__buttonColor}D9 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="3.0"] .noUi-touch-area{
    background: ${__buttonColor}B9 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="4.0"] .noUi-touch-area{
    background: ${__buttonColor}8F !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="5.0"] .noUi-touch-area{
    background: ${__buttonColor}70 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="6.0"] .noUi-touch-area{
    background: ${__buttonColor}8F !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="7.0"] .noUi-touch-area{
    background: ${__buttonColor}B9 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="8.0"] .noUi-touch-area{
    background: ${__buttonColor}D9 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="9.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }

  /* 11 options  */

  .polarity-slider9 .noUi-handle[aria-valuenow="1.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="2.0"] .noUi-touch-area{
    background: ${__buttonColor}D9 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="3.0"] .noUi-touch-area{
    background: ${__buttonColor}B9 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="4.0"] .noUi-touch-area{
    background: ${__buttonColor}8F !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="5.0"] .noUi-touch-area{
    background: ${__buttonColor}60 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="6.0"] .noUi-touch-area{
    background: ${__buttonColor}70 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="7.0"] .noUi-touch-area{
    background: ${__buttonColor}60 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="8.0"] .noUi-touch-area{
    background: ${__buttonColor}8F !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="9.0"] .noUi-touch-area{
    background: ${__buttonColor}B9 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="10.0"] .noUi-touch-area{
    background: ${__buttonColor}D9 !important;
  }
  .polarity-slider9 .noUi-handle[aria-valuenow="11.0"] .noUi-touch-area{
    background: ${__buttonColor}FF !important;
  }

  `;
}

function getBoxQuestionStyle(
  _boxQuestionType: string,
  _buttonColor: string,
): string {
  let style = '';

  switch (_boxQuestionType) {
    case '1':
      style = `
        .sv-page.sv-body__page .sv-row.sv-clearfix {
          border: 1px solid ${_buttonColor};
          border-radius: 20px;
          padding-left: 6px;
          background: ${_buttonColor};
          padding-bottom: 0;
        }

        .sv-page.sv-body__page .sv-row.sv-clearfix > div {
          min-width: 0 !important;
          background: white;
          border-radius: 20px;
          padding: 15px;
        }
      `;
      break;

    case '2':
      style = ``;
      break;

    default:
      style = ``;
      break;
  }

  return style;
}

function getButtonStyle(_buttonStyle: string, _buttonColor: string): string {
  let style = '';

  switch (_buttonStyle) {
    case '1':
      style = `
        .sv-root-modern .sv-btn--navigation {
          background-color: ${_buttonColor} !important;
        }
      `;
      break;

    case '2':
      style = `
        .sv-root-modern .sv-btn--navigation {
          background-color: ${_buttonColor} !important;
          border-bottom-left-radius: 10px !important;
          border-bottom-right-radius: 0 !important;
          border-top-right-radius: 10px !important;
          border-top-left-radius: 0 !important;
        }
      `;
      break;

    default:
      style = `
        .sv-root-modern .sv-btn--navigation {
          background-color: ${_buttonColor} !important;
        }
      `;
      break;
  }

  return style;
}

function getButtonPosition(_buttonPosition: string): string {
  switch (_buttonPosition) {
    case 'left':
      return `
        .sv-root-modern .sv-footer .sv-action--hidden {
          display: none !important;
        }

        .sv-root-modern .sv-footer #sv-nav-next,
        .sv-root-modern .sv-footer #sv-nav-complete {
          margin-left: 0 !important;
          margin-right: auto !important;
        }
      `;

    case 'right':
      return `
        .sv-root-modern .sv-footer .sv-action--hidden {
          display: none !important;
        }

        .sv-root-modern .sv-footer #sv-nav-next,
        .sv-root-modern .sv-footer #sv-nav-complete {
          margin-left: auto !important;
          margin-right: 0 !important;
        }
      `;

    default:
      return '';
  }
}

function getCss(
  _buttonColor: string,
  _buttonStyle: string,
  _boxQuestionType: string,
  _displayFinalMessage: string,
  _hideProgressText: string,
  _buttonPosition: string,
  _fontFamily: string,
): any {
  const polaritySliderClasses = getPolaritySliderClasses(_buttonColor);
  const fontFamilyOverride = _fontFamily
    ? `
    &, & * {
      font-family: ${_fontFamily} !important;
    }
    /* Bar-rating stars are FontAwesome glyphs (private-use chars) — the survey
       font override must not apply to them, otherwise they render as tofu. */
    & .br-widget a,
    & .br-widget a:after {
      font-family: FontAwesome !important;
    }
  `
    : '';
  const cssTso = `

  ${fontFamilyOverride}

  .podiumNumber {
    color: ${_buttonColor} !important;
    border: 8px solid ${_buttonColor}aa !important;
  }
  .boxAnswersColumnPodium {
    background-color: ${_buttonColor}aa !important;
  }
  .spnBoxQuestions {
    background-color: ${_buttonColor} !important;
  }

  .spnMobileBoxQuestions {
    background-color: ${_buttonColor} !important;
  }

  .sv-progress__text {
    display: ${_hideProgressText}
  }

  .sv-ranking-item__content{
    background-color: transparent !important;
  }

  @media (max-width: 350px){
    .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-question table.sv-matrix-root .sv-matrix__cell, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-row__question table.sv-matrix-root .sv-matrix__cell {
      text-align: initial !important;
      margin-left: 0 !important;
    }
    td .sv-string-viewer {
      font-weight: 700;
    }
    td {
      padding-left: 0.3vw !important;
    }
    .sv-question__content {
      margin-left: 0 !important;
    }
  }

  .sv-question__content .sv-image .sv_image_image {
    width: 100%;
  }

  table.sv-matrix-root {
    background-color: transparent;
  }

  @media (max-width: 844px){
    .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-question table.sv-matrix-root .sv-matrix__cell, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-row__question table.sv-matrix-root .sv-matrix__cell {
      text-align: initial !important;
      margin-left: 0;
      padding-left: 0;
    }
    .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-question table.sv-matrix-root td:first-child, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-row__question table.sv-matrix-root td:first-child {
      padding-left: 0;
    }
    td .sv-string-viewer {
      font-weight: 700;
      /* break long statement tokens so the matrix table fits its wrapper
         (.sv-matrix overflow-x:auto) and doesn't show a horizontal scrollbar */
      word-break: break-word;
    }
  }



  @media (max-width: 844px){
    .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-question table.sv-table tbody, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-question table.sv-table tr, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-question table.sv-table td, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-row__question table.sv-table tbody, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-row__question table.sv-table tr, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-row__question table.sv-table td {
      display: block;
    }

    .sv-root-modern .sv-table th {
        display: none !important;
      }

      .sv-table .sv-table__cell {
        padding-top: 0.25em;
        margin-top: 0px;
    }

    .sv-table__cell {
      padding: 2px 10px;
      box-sizing: content-box;
      vertical-align: top;
    }

    .sv-table tbody tr .sv-table__cell {
      padding-bottom: 0.25em!important;
    }

    .sv-table tbody tr {
      margin-bottom: 1.25em;
    }

    .sv-table tr:first-child .sv-table__cell {
      padding-top: 0.25em;
  }

  }

  @media (max-width: 844px){
    /* on mobile the matrix behaves like a Scale question: the whole option
       (radio + text) is clickable and the selected option gets a colored row.
       the option text already exists inside the <label> (span.sv-hidden), so we
       reveal it there instead of the td:after pseudo -> the label wraps the
       text, giving native click-to-select. layout/font of the label are left
       stock (untouched) so the <=600px sizing keeps behaving as before. */
    .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-question table.sv-matrix-root td:after, .sv-root-modern .sv-container-modern .sv-body .sv-page .sv-row .sv-row__question table.sv-matrix-root td:after {
      content: none !important;
    }

    table.sv-matrix-root .sv-matrix__cell .sv-matrix__label .sv-hidden {
      display: inline !important;
    }

    /* the statement text is bold via "td .sv-string-viewer"; keep option text normal */
    table.sv-matrix-root .sv-matrix__cell .sv-matrix__label .sv-string-viewer {
      font-weight: 400;
    }

    /* highlight on the cell (block-level on mobile) so the colored row spans the
       full width regardless of the label being inline */
    table.sv-matrix-root .sv-matrix__cell:has(.sv-radio--checked) {
      background-color: ${_buttonColor}1f;
    }

    .sv-table tbody tr .sv-table__cell {
      padding-bottom: 0.25em!important;
    }
  }

  .sv-action-bar.sv-action-bar--default-size-mode.sv-footer.sv-body__footer.sv-clearfix {
    margin-top: 0;
    margin-bottom: 10px;
  }

  .formContact button {
    padding: 5px 10px;
    background-color: ${_buttonColor} !important ;
    color: #fff;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    margin-top:15px;
  }

  .formContact button[disabled] {
    background-color: ${_buttonColor}80 !important ;
    cursor: not-allowed;
  }

  .sv-page.sv-body__page {
    display: flex;
    flex-direction: column;
    gap: 2vh;
  }

  ${getBoxQuestionStyle(_boxQuestionType, _buttonColor)}

  .formContact input[type="checkbox"] {
    appearance: none;
    width: 24px;
    height: 24px;
    border: 2px solid ${_buttonColor} !important;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 5px;
    /* margin-bottom: 15px; */
    display: inline-block;
    vertical-align: middle;
  }

  .formContact input[type="checkbox"]:checked {
    background-color: ${_buttonColor} !important;
    border: 2px solid ${_buttonColor} !important;
  }



  .sv-root-modern .sv-container-modern__title {
    color: ${_buttonColor} !important;
  }

  .sv-root-modern .sv-container-modern__title {
    color:${_buttonColor} !important;
  }

  ${getButtonStyle(_buttonStyle, _buttonColor)}

  ${getButtonPosition(_buttonPosition)}

 .sv-root-modern .sv-checkbox--checked .sv-checkbox__svg {
      background-color: ${_buttonColor}bf !important;
      fill: rgb(255, 255, 255);
  }

  /* star rating (jquery-bar-rating): each star's label is a native title
     tooltip that only shows on desktop hover. on touch, the widget JS
     (EbStyledRating) moves a single .eb-star-tip bubble into the selected
     star's <a>, and this CSS positions it above that <a> (so it follows the
     star on resize/rotate with no JS math). a single moved element is used
     instead of a per-star ::before because iOS Safari does not reliably repaint
     per-star pseudo tooltips when the selection moves, leaving "ghost" bubbles
     stacked. hidden by default — desktop uses the native title; revealed on
     touch by the @media rule below. */
  .br-widget a .eb-star-tip {
    display: none;
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 8px;
    background: #fff;
    color: #333;
    border: 1px solid #333;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
  }

  /* on touch devices a tap leaves :hover stuck, so the grey hover state
     lingers on checkbox/radio options. only keep item hover on real pointers
     (desktop); neutralize it where the device has no hover (mobile). */
  @media (hover: none) {
    .sv-root-modern .sv-checkbox--allowhover:hover .sv-checkbox__svg {
      border: 3px solid rgba(64, 64, 64, 0.5);
      background-color: transparent;
      fill: transparent;
    }
    .sv-root-modern .sv-radio--allowhover:hover .sv-radio__svg {
      fill: transparent;
    }
    /* keep the checked radio dot visible despite the stuck :hover (the
       checkbox checked state is already protected by the !important above) */
    .sv-root-modern .sv-radio--allowhover.sv-radio--checked:hover .sv-radio__svg {
      fill: #404040;
    }

    /* reveal the star tooltip bubble on touch, give the star <a> a positioning
       context, and flip the edge stars so the bubble never overflows */
    .br-widget a {
      position: relative;
    }
    .br-widget a .eb-star-tip {
      display: block;
    }
    .br-widget a:first-child .eb-star-tip {
      left: 0;
      transform: none;
    }
    .br-widget a:last-child .eb-star-tip {
      left: auto;
      right: 0;
      transform: none;
    }
  }

  .sv-root-modern .sv-question__title--answer {
    background-color: ${_buttonColor}0f !important;
  }

  .sv-root-modern .sv-progress__bar {
    background-color: ${_buttonColor} !important;
  }

  .sv-root-modern ::-webkit-scrollbar-thumb {
    background: ${_buttonColor} !important;
  }

  .sv-root-modern ::-webkit-scrollbar-thumb {
    background: #284158 !important;
  }

  .sv-root-modern .sv-comment:focus {
    border-color: #284158 !important;
  }

  .br-theme-css-stars .br-widget a.br-selected:after {
    color: ${_buttonColor}bf !important;
  }

  .br-theme-fontawesome-stars-o .br-widget a.br-selected:after{
    color: ${_buttonColor}bf !important;
  }

  .br-theme-fontawesome-stars .br-widget a.br-selected:after {
    color: ${_buttonColor}bf !important;
  }

  .noUi-connect {
    background: ${_buttonColor}bf !important;
  }

  .noUi-touch-area{
    background: ${_buttonColor}bf !important;
    border-radius: 0.3rem !important;
  }

  ${polaritySliderClasses}

  .noUi-handle{
    border-radius: 0.3rem !important;
  }

  .sv-root-modern .sv-rating__item--selected .sv-rating__item-text {
    background-color: ${_buttonColor}bf !important;
    color: rgb(255, 255, 255);
    border-color: ${_buttonColor}bf !important;
  }

  .body {
    --primary-color: ${_buttonColor} !important;
    --secondary-color: ${_buttonColor} !important;
    --primary-text-color: #676a6c !important;
    --secondary-text-color: #a7a7a7 !important;
    --inverted-text-color: #ffffff !important;
    --primary-hover-color: ${_buttonColor} !important;
    --selection-border-color: ${_buttonColor} !important;
    --primary-icon-color: #3d4d5d !important;
    --primary-bg-color: #fff !important;
    --secondary-bg-color: #f4f4f4 !important;
    --primary-border-color: #e7eaec !important;
    --secondary-border-color: #ddd !important;
    --error-color: #ed5565 !important;
  }

  .br-widget a[data-rating-value="none"].br-selected.br-current::after {
    color: #810000 !important;
  }

  .br-theme-bars-pill .br-widget a {
    padding: 7px 15px;
     background-color: ${_buttonColor}9f !important;
    font-size: 13px;
    line-height: 3;
    text-align: center;
    font-weight: 400;
  }

  .br-theme-bars-movie .br-widget a.br-active, .br-theme-bars-movie .br-widget a.br-selected {
    background-color:  ${_buttonColor} !important;
    color: rgb(206, 206, 206);
  }

  .br-theme-bars-square .br-widget a.br-active, .br-theme-bars-square .br-widget a.br-selected {
    border: 2px solid  ${_buttonColor} !important;
  }

  .br-theme-bars-movie .br-widget a {
    display: block;
    text-align: center;
    width: 130px;
    height: 25px;
    float: left;
    background-color: ${_buttonColor}7f !important;
    margin: 1px;
    color: rgb(70, 71, 71);
  }

  .br-theme-bars-square .br-widget a {
    display: block;
    width: 30px;
    height: 30px;
    float: left;
    border: 2px solid ${_buttonColor}6f !important;
    background-color: white;
    margin: 2px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 2;
    text-align: center;
    color: #bbcefb;
    font-weight: 600;
  }

  .br-theme-bars-reversed .br-widget a {
    display: block;
    width: 22px;
    height: 22px;
    float: left;
    background-color: ${_buttonColor}9f !important;
    margin: 1px;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.4;
    color: red;
    text-align: center;
  }

  .br-theme-bars-pill .br-widget a.br-active, .br-theme-bars-pill .br-widget a.br-selected {
    background-color: ${_buttonColor} !important;
    color: white;
  }

  .br-theme-bars-reversed .br-widget a.br-active, .br-theme-bars-reversed .br-widget a.br-selected {
      background-color: ${_buttonColor} !important;
      color: white;
  }

  .sv-question {
    overflow: visible;
  }

  .noUi-value-horizontal {
    overflow-wrap: break-word;
    hyphens: manual;
    white-space: normal;
    top: 0;
    height: inherit;
  }

  .sv-item.sv-radio.sv-selectbase__item.sv-q-col-1.sv-radio--checked {
    background-color: ${_buttonColor}1f !important;
  }

  .sv-btn.sv-action-bar-item, .sv-btn {
    appearance: none;
    border: none;
    border-radius: 1.214em;
    cursor: pointer;
    font-family: Roboto;
    font-size: 0.875em;
    font-weight: bold;
    outline: none;
    padding: 0.5em 1.786em 0.6em;
    text-align: left;
  }

  .sv-action-bar.sv-action-bar--default-size-mode.sv-footer.sv-body__footer.sv-clearfix {
    display: flex;
  }

  .sv-completedpage {
    padding-top: 30px!important;
    padding-bottom: 5px!important;
    height: auto!important;
    line-height: 1.3em!important;
    background: transparent !important;
    display: ${_displayFinalMessage};
    display: flex !important;
    flex-direction: column !important;
  }

  .sv-completedpage > h3 {
    margin-top: 0 !important;
  }

  .sv-completedpage:before {
    display: none !important;
  }

  .sv-root-modern .sv-rating input:focus + .sv-rating__min-text + .sv-rating__item-text, .sv-rating input:focus + .sv-rating__item-text {
    outline-color: white;
   }

  .sv-root-modern .sv-rating__item-text {
    color: #4D4646;
    border: 0.1875em solid ${_buttonColor};
  }



  .sv-header__text > h3 {
     margin-bottom: 10px;
   }

  .sv-header__text > h5 {
    font-weight: 300;
  }

  @media (max-width: 1126px) {
   .sv-header__text {
     margin-left: 0vw;
     margin-bottom: 1vh;
   }
  }

  @media (max-width: 700px) {

    .br-theme-bars-pill .br-widget {
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-content: center;
      align-items: stretch;
    }

    .br-theme-bars-pill .br-widget a:first-child {
      -webkit-border-top-left-radius: 999px;
      -webkit-border-top-right-radius: 999px;
      border-bottom-left-radius: 0;
      bordert-top-left-radius: 0;
    }

    .br-theme-bars-pill .br-widget a:last-child {
      border-bottom-left-radius: 0 !important;
      bordert-top-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      border-top-right-radius: 0 !important;
    }

    .sv-container-modern fieldset {
      border: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: baseline;
    }

    .sv-rating__item {
      width:100%;
    }

    .sv-root-modern .sv-rating__item-text {
      width:100%;
    }


    .sv-rating__item-text > span {
      margin: 0.44em 0;
    }
  }

`;
  return cssTso;
}

export const Header = styled.header<HeaderProps>`
  width: 100%;
  top: 0;
  z-index: 1000;
  height: 190px;

  display: flex;
  padding: 23px;
  justify-content: center;

  /* shrink the header on mobile so it takes less vertical space */
  @media (max-width: 844px) {
    padding: 5px 10px 10px;
    height: unset;
  }

  div {
    img {
      max-width: ${props => (props.$useStyle ? props.$sizeLogo : '100%')};

      @media (max-width: 500px) {
        max-width: 80%;
      }
    }

    background: ${props => (props.$useStyle ? props.$headerColor : '#e0e0e0')};
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 20px;
    z-index: 1000;
    width: 100%;
    height: 160px;
    object-fit: cover;
    object-position: 0 0;

    @media (max-width: 844px) {
      height: unset;
    }
  }
`;

// export const Header = styled.header<HeaderProps>`
//   width: 100%;
//   height: 75px;
//   background: ${props => (props.$useStyle ? props.$headerColor : '#e0e0e0')};
//   /* background-color: #e0e0e0; */
//   padding: 10px 0;
//   position: ${props => {
//     return 'relative';
//   }};

//   top: 0;
//   z-index: 1000;

//   display: flex;
//   justify-content: center;
//   align-items: center;

//   box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 30%);
//   overflow: hidden;

//   img {
//     max-height: ${props => (props.$useStyle ? props.$sizeLogo : '100%')};
//   }
// `;

export const HeaderImage = styled.header<HeaderProps>`
  width: 100%;
  top: 0;
  z-index: 1000;
  height: 190px;

  display: flex;
  padding: 23px;
  justify-content: center;

  img {
    &.backgroundHeader {
      border-top-right-radius: 20px;
      border-bottom-left-radius: 20px;
      z-index: 1000;
      width: 100%;
      height: 160px;
      object-fit: cover;
      object-position: 0 0;
    }
  }

  div {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
    height: 75px;

    img {
      max-height: ${props => (props.$useStyle ? props.$sizeLogo : '100%')};
    }
  }
`;

export const Container = styled.div<ContainerProps>`
  /* max-width: 1260px; */
  background-color: rgba(255, 255, 255, 0.8); /*80% opacity*/
  height: 90%;
  width: 95%;
  top: 40px;
  margin: 0 auto;
  /* padding: 0 24px 24px; */
  /* position: relative; */
  font-family: Roboto;

  @media (max-width: 1300px) {
    max-width: 100%;
  }

  ${props =>
    props.$useStyle
      ? css`
          ${getCss(
            props.$mainColor,
            props.$buttonStyle,
            props.$boxQuestionType,
            props.$showFinalMessage ? 'block !important' : 'none',
            props.$hideProgressText && props.$hideProgressText === true
              ? 'none'
              : 'block',
            props.$buttonPosition ?? '',
            props.$fontFamily ?? '',
          )}
        `
      : ''};

  ${props =>
    props.$showFinalMessage
      ? css`
          .sv-title.sv-container-modern__title {
            display: none !important;
          }
        `
      : ''};

  .button-fortfahren {
    font-weight: 500px;
    margin-top: 16px;
    margin-right: 35px;
    width: 200px;
    height: 35px;
    background: #47283a;
    color: #ffff;
    display: block;
    padding: 0 16px;
    border: 0px;
    border-radius: 10px;
    box-shadow: none;
    transition: 0.2s ease 0s;
    &:hover {
      background: #5c344ceb;

      color: #eeee;
    }
  }
`;

export const Content = styled.div`
  position: relative;
  top: 30px;

  @media (max-width: 600px) {
    /* start-text images are often authored with float:right + fixed px sizes,
       which wrap badly on mobile. drop the float and make them a centered,
       responsive block so the text reads cleanly above/below the image. */
    img {
      float: none !important;
      display: block;
      max-width: 100% !important;
      height: auto !important;
      margin: 12px auto;
    }
  }

  p {
    margin: 12px 0;
  }

  p.title {
    font-size: 1.2em;
    font-weight: bold;
  }

  p.small {
    font-size: 12px;
    margin: 10px 0 30px;
  }

  div.text,
  svg {
    line-height: 50px;
    vertical-align: middle;
    font-size: 30px;
  }
`;

export const Footer = styled.footer``;

export const ButtonMoreInfo = styled(Button)`
  width: 200px;
  height: 35px;
  background: #0000000d;
  padding: 10px 15px;
  font-size: x-small;
  text-decoration: none;
  color: #2289bd;
  margin: 0 0 25px;
  display: block;
  float: right;

  &:hover {
    background: #efefef;
    color: #8ec1db;
    opacity: 0.8;
  }
`;

export const ButtonNext = styled(Button)<ButtonStyle>`
  margin-right: 35px;
  width: 200px;
  height: 35px;
  color: #ffff;
  display: block;
  font-family: Roboto;

  /* background: #47283a; */
  background: ${props => (props.$buttonColor ? props.$buttonColor : '#47283a')};

  &:hover {
    /* opacity: 0.8;
    color: #eeee; */
    background: ${props =>
      props.$buttonColor ? `${props.$buttonColor}8f` : 'blue'};
  }
`;

export const GDPRText = styled.p`
  font-size: x-small;
  color: #aaa;
  margin: 50px 0 30px !important;

  a {
    color: #017698;
    text-decoration: underline;
    margin-left: 5px;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const AlertMessage = styled.div`
  margin: 100px 0;
  padding: 24px;
  color: #3172b7;
  background-color: #ebf8ff;
  border-color: #3172b7;
  border: 1px solid transparent;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  flex-direction: column;

  svg {
    margin-right: 24px;
  }
`;

export const AlertMessageLeaving = styled.div`
  margin: auto;
  padding: 24px;
  color: #3172b7;
  background-color: #ebf8ff;
  border-color: #3172b7;
  border: 1px solid transparent;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  flex-direction: column;

  svg {
    margin-right: 24px;
  }
`;

export const SurveyContent = styled.div`
  width: 100%;
  padding: 2dvw;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RootDivFonts = styled.div<BackgroundImageProps>`
  /* The global reset sets a line-height of 1.5em on the body, and an em value
     is inherited as an already computed length (24px), not as a ratio. Any
     text with its own font-size - e.g. an html element with font-size: 60px -
     would then be laid out in a 24px line box and overflow it, which the
     "overflow: auto" of .sv-question turns into a clipped, scrollable box.
     A unitless value is inherited as a factor, so every element computes its
     line box from its own font-size and the box grows with the text.
     16px text keeps exactly the same line-height it has today. */
  line-height: 1.5;

  /* background-image: url('https://i.pinimg.com/originals/50/a7/8b/50a78b21b11300c8e71ec378ebdbaabf.jpg'); */
  background-image: url(${props => props.$urlBackground});
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  height: auto;
  width: ${props => props.$boxSize}%;

  @media (max-width: 600px) {
    width: 100%;
  }

  display: flex;
  flex-direction: column;

  border: 1px solid ${props => props.$buttonColor};
  border-top-right-radius: 25px;
  border-bottom-left-radius: 25px;
  min-height: 93vh;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3), 0 8px 16px rgba(0, 0, 0, 0.15),
    0 16px 32px rgba(0, 0, 0, 0.3);

  /* Thin */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-Thin.ttf) format('truetype');
    font-style: normal;
    font-weight: 100;
  }

  /* Thin Italic */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-ThinItalic.ttf) format('truetype');
    font-style: italic;
    font-weight: 100;
  }

  /* Light */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-Light.ttf) format('truetype');
    font-style: normal;
    font-weight: 300;
  }

  /* Light Italic */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-LightItalic.ttf) format('truetype');
    font-style: italic;
    font-weight: 300;
  }

  /* Normal */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-Regular.ttf) format('truetype');
    font-style: normal;
    font-weight: 400;
  }

  /* Normal Italic */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-Italic.ttf) format('truetype');
    font-style: italic;
    font-weight: 400;
  }

  /* Medium */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-Medium.ttf) format('truetype');
    font-style: normal;
    font-weight: 500;
  }

  /* Medium Italic */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-MediumItalic.ttf) format('truetype');
    font-style: italic;
    font-weight: 500;
  }

  /* Bold */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-Bold.ttf) format('truetype');
    font-style: normal;
    font-weight: 700;
  }

  /* Bold Italic */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-BoldItalic.ttf) format('truetype');
    font-style: italic;
    font-weight: 700;
  }

  /* Black */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-Black.ttf) format('truetype');
    font-style: normal;
    font-weight: 900;
  }

  /* Black Italic */
  @font-face {
    font-family: 'Roboto';
    src: local('Roboto'),
      url(../../fonts/Roboto/Roboto-BlackItalic.ttf) format('truetype');
    font-style: italic;
    font-weight: 900;
  }

  /* GenosGFG_Desktop - Regular */
  @font-face {
    font-family: 'GenosGFG_Desktop';
    src: local('GenosGFG_Desktop'),
      url(../../fonts/GenosGFG_Desktop/GenosGFG_Desktop_Office_App/GenosGFG-Regular.ttf)
        format('truetype');
    font-style: normal;
    font-weight: 400;
  }

  /* GenosGFG_Desktop - Regular Italic */
  @font-face {
    font-family: 'GenosGFG_Desktop';
    src: local('GenosGFG_Desktop'),
      url(../../fonts/GenosGFG_Desktop/GenosGFG_Desktop_Office_App/GenosGFG-RegularItalic.ttf)
        format('truetype');
    font-style: italic;
    font-weight: 400;
  }

  /* GenosGFG_Desktop - Bold */
  @font-face {
    font-family: 'GenosGFG_Desktop';
    src: local('GenosGFG_Desktop'),
      url(../../fonts/GenosGFG_Desktop/GenosGFG_Desktop_Office_App/GenosGFG-Bold.ttf)
        format('truetype');
    font-style: normal;
    font-weight: 700;
  }

  /* GenosGFG_Desktop - Bold Italic */
  @font-face {
    font-family: 'GenosGFG_Desktop';
    src: local('GenosGFG_Desktop'),
      url(../../fonts/GenosGFG_Desktop/GenosGFG_Desktop_Office_App/GenosGFG-BoldItalic.ttf)
        format('truetype');
    font-style: italic;
    font-weight: 700;
  }

  /* GenosGFG_Desktop - Condensed */
  @font-face {
    font-family: 'GenosGFG_Desktop';
    src: local('GenosGFG_Desktop'),
      url(../../fonts/GenosGFG_Desktop/GenosGFG_Desktop_Office_App/GenosGFG-Condensed.ttf)
        format('truetype');
    font-style: normal;
    font-stretch: condensed;
    font-weight: 400;
  }

  /* GenosGFG_Web - Regular */
  @font-face {
    font-family: 'GenosGFG_Web';
    src: local('GenosGFG_Web'),
      url(../../fonts/GenosGFG_Web/GenosGFG_Web/GenosGFG-Regular.ttf)
        format('truetype');
    font-style: normal;
    font-weight: 400;
  }

  /* GenosGFG_Web - Regular Italic */
  @font-face {
    font-family: 'GenosGFG_Web';
    src: local('GenosGFG_Web'),
      url(../../fonts/GenosGFG_Web/GenosGFG_Web/GenosGFG-RegularItalic.ttf)
        format('truetype');
    font-style: italic;
    font-weight: 400;
  }

  /* GenosGFG_Web - Bold */
  @font-face {
    font-family: 'GenosGFG_Web';
    src: local('GenosGFG_Web'),
      url(../../fonts/GenosGFG_Web/GenosGFG_Web/GenosGFG-Bold.ttf)
        format('truetype');
    font-style: normal;
    font-weight: 700;
  }

  /* GenosGFG_Web - Bold Italic */
  @font-face {
    font-family: 'GenosGFG_Web';
    src: local('GenosGFG_Web'),
      url(../../fonts/GenosGFG_Web/GenosGFG_Web/GenosGFG-BoldItalic.ttf)
        format('truetype');
    font-style: italic;
    font-weight: 700;
  }

  /* GenosGFG_Web - Condensed */
  @font-face {
    font-family: 'GenosGFG_Web';
    src: local('GenosGFG_Web'),
      url(../../fonts/GenosGFG_Web/GenosGFG_Web/GenosGFG-Condensed.ttf)
        format('truetype');
    font-style: normal;
    font-stretch: condensed;
    font-weight: 400;
  }

  .sv-container-modern__title h3 {
    font-size: 2.3vw;

    @media (max-width: 1200px) {
      font-size: 3vw;
    }

    @media (max-width: 600px) {
      font-size: 5vw;
    }

    @media (max-width: 300px) {
      font-size: 5vw;
    }
  }

  .sv-title {
    font-family: 'Roboto';
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    font-size: 18px;
  }

  .sv-question {
    overflow: auto;
    box-sizing: border-box;
    font-family: 'Roboto';
  }

  .sv-body {
    font-family: 'Roboto';
  }
`;

export const HiddenBubbleTree = styled.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: max-content;
  height: max-content;
  overflow: visible;
`;

export const HiddenChart = styled.div`
  position: fixed;
  top: -100000px;
  left: -100000px;
  pointer-events: none;
  opacity: 1;
  z-index: -1;
  font-family: 'Dosis', sans-serif;

  * {
    font-family: 'Dosis', sans-serif;
  }
`;

export const HiddenChartRadar = styled.div`
  position: fixed;
  top: -100000px;
  left: -100000px;
  pointer-events: none;
  opacity: 1;
  z-index: -1;
  font-family: 'Open Sans', 'Segoe UI', sans-serif;

  * {
    font-family: 'Open Sans', 'Segoe UI', sans-serif;
  }
`;
